<ng-template #nodeTpl let-node let-depth="depth">
  <div class="lane-item" [class]="node.status" [class.planned]="isPlanned(node)" [style.--depth]="depth">
    <span class="dot"></span>
    <div class="content">
      <div class="name">{{ node.name }}</div>
      @if (node.asIsDate) {
        <div class="date">{{ node.asIsDate | yomaDateFormat: 'eeeeee. dd.MM.yyyy' }}</div>
      }
      @if (node.toBeDate) {
        <div class="date planned">geplant: {{ node.toBeDate | yomaDateFormat: 'eeeeee. dd.MM.yyyy' }}</div>
      }
      @if (!node.asIsDate && !node.toBeDate) {
        <div class="date placeholder">&mdash;</div>
      }
    </div>
  </div>
  @if (node.children.length) {
    <div class="children">
      @for (child of node.children; track child.id) {
        <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: child, depth: depth + 1 }"></ng-container>
      }
    </div>
  }
</ng-template>

<div class="lane-list" [class.cancelled]="cancelled">
  @for (node of nodes; track node.id) {
    <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: node, depth: 0 }"></ng-container>
  }
</div>
